import { useContext } from 'react';
import { RouterRequestContext } from '../routerContext';
export function useRouterRequest() {
    return useContext(RouterRequestContext);
}
